import { createReducer, on } from "@ngrx/store";

import {
  exitKioskModeBundle,
  loadEventDetailsBundle,
  loadKioskModeBundle,
} from "./bundles";
import { IMeetingRoomKioskData } from "../models/kiosk.model";
import { IMeetingRoomKioskEventDetailsData } from "../models/kiosk.model";

export interface MeetingRoomsKioskState {
  meetingRoomKioskData: IMeetingRoomKioskData | null;
  eventDetails: IMeetingRoomKioskEventDetailsData | null;
}

export const initialState: MeetingRoomsKioskState = {
  meetingRoomKioskData: null,
  eventDetails: null,
};

export const meetingRoomsKioskReducer = createReducer(
  initialState,

  on(loadKioskModeBundle.loadKioskModeSuccess, (state, { data }) => {
    return { ...state, meetingRoomKioskData: data };
  }),
  on(
    loadEventDetailsBundle.loadEventDetailsSuccess,
    (state, { eventDetails }) => {
      return {
        ...state,
        eventDetails,
      };
    },
  ),
  on(loadEventDetailsBundle.loadEventDetailsCleanup, (state) => {
    return { ...state, eventDetails: null };
  }),
  on(exitKioskModeBundle.exitKioskModeSuccess, (state) => {
    return { ...state, meetingRoomKioskData: null };
  }),
);
